/* global BMS*/
import {
    ADD_LOCAL_STORED_BETS,
    ADD_OPEN_BET,
    CLEAR_OPEN_BETS_LIST,
    DISABLE_QUICK_FILL,
    DO_QUICK_FILL_BETS,
    REMOVE_CLOSED_EVENTS_OPEN_BETS,
    REMOVE_OPEN_BET,
    TOGGLE_COMMIT_BETS_ERROR,
    TOGGLE_COMMIT_BETS_SUCCESS,
    TOGGLE_COMMITTING_BETS,
    TOGGLE_QUICK_FILL,
    TOOGLE_EW_BET,
    UPDATE_OPEN_BET_MULTIPLIER,
    UPDATE_OPEN_BET_STAKE,
    APPLY_PROMO_BET,
    SELECTED_BET,
    REMOVE_PROMO_BET,
    AUTO_FOCUS_QUICK_FILL,
    UPDATE_UI_STATE,
    UPDATE_UI_STATE_TIMER,
    UNCHECK_QUICK_FILL
} from '../constants/actionTypes';
import {ENABLED, OPEN_BETS, PLACED_BETS} from '../../../constants/identifiers';
import {PLACE, REVERSE_FORECAST, REVERSE_TRICAST, SHOW} from '../modules/racing/constants/identifiers';
import defaultStoreValues from '../../../constants/defaultStoreValues';
import {getOdd} from '../modules/racing/helpers/betFunctions';
import {
    _generateAccumulatorBets,
    _removeSingleBets,
    _updateExistingAccBets,
    getFormattedInputValue,
    getQuickAmountDistribution,
    updateSportsBookLocalOpenBets,
    amountConvertToMajorCurrency,
    filterOutRealBetsFromOpenlist, isAccaBetPresentInBetSlip, removePromoBetAndAccaBet
} from '../helpers/betHelpers';
import {getItem} from "../../../helpers/localStorageHelpers";
import {DEFAULT_STAKES} from "../../../constants/localStorage"
import {isDogsEvent} from "../modules/racing/helpers/racersHelper"
import {isMatchDay} from "../modules/matchday/helpers/matchdayHelper";
import device from 'current-device';
const _ = require('lodash');

export default (state, action) => {
    let newSelectedEventMultiBetList = state.selectedEventMultiBetList.slice();
    let newOpenBetsList = state.openBetsList.slice();
    let newOpenBetsSimpleList = state.openBetsSimpleList.slice();
    let newIsBetSlipModalOpen = state.isBetSlipModalOpen;
    let newSelectedBetSlipScreen = state.selectedBetSlipScreen;
    let newBetSelection;
    let newMyOfferList = state.promoBalances.slice();
    let atleastOneValidAccaPresent;
    switch (action.type) {
        case ADD_OPEN_BET:
            // This validation moved from addBet Action to here, the validation was not considering
            // the server time offset and here we have access to the value on the store.
            let todayDate = new Date() - state.serverTimeOffset;
            if (action.bet.event.eventTimeDate < todayDate) {
                return state;
            }

            newSelectedEventMultiBetList = defaultStoreValues.selectedEventMultiBetList.slice();

            // ensure racers on "ANY" bets are ordered
            if ((action.bet.betType === REVERSE_FORECAST || action.bet.betType === REVERSE_TRICAST) && action.bet.racers !== undefined && action.bet.racers.length > 1) {
                action.bet.racers = action.bet.racers.sort((a, b) => a.num - b.num);
            }

            let stakeValue = '';
            let stakeValues = getItem(state.playerUID, DEFAULT_STAKES);
            if (stakeValues && stakeValues[action.bet.game.channel]) {
                stakeValue = stakeValues[action.bet.game.channel];
            }

            newBetSelection = {
                bets: [action.bet],
                stake: null
            };

            // set the odds on bet market if they dont exist to allow for future value checks upon placing the bet this is only done for
            // racing as football already has the odds defined on the original market
            if (action.bet.market.odds === undefined) {
                newBetSelection.bets[0].market.odds = getOdd(newBetSelection);
            }

            newOpenBetsSimpleList.push(newBetSelection);
            newOpenBetsList.push(newBetSelection);
            let isAccaBetPresent = false;

            if (isMatchDay(action.bet.event.eventType)) {
                //Generate matchday accumulator
                isAccaBetPresent = _generateAccumulatorBets(newOpenBetsList, newOpenBetsSimpleList);

            }
            atleastOneValidAccaPresent = isAccaBetPresentInBetSlip(newOpenBetsList);

            if (state.openBetsList.length === 0 && !(device.mobile() && !device.tablet())) {
                newIsBetSlipModalOpen = true;
                newSelectedBetSlipScreen = OPEN_BETS;
            }
            let betsWithOutMultiplierArr = newOpenBetsList.filter(bet => bet.bets.length === 1);
            if (newOpenBetsList.length > 0 && state.quickFillBoxChecked && state.quickFillStake !== '' && !atleastOneValidAccaPresent) {
                let distributions = getQuickAmountDistribution(state.quickFillStake, (process.env.NODE_ENV !== 'development' && BMS && BMS.authentication && BMS.authentication.isPlayerLogged && state.playerBalance)
                    ? state.playerBalance.Banks.CREDIT.MinorCurrencyUnits
                    : 2, filterOutRealBetsFromOpenlist(betsWithOutMultiplierArr).length);
                let distributionIndex = 0;
                newOpenBetsList = newOpenBetsList.map((openBet, index) => {
                    if (openBet.hasOwnProperty('PromoBetId')) {
                        return { ...openBet };
                    }
                    if (openBet.hasOwnProperty('multiplier') || openBet.bets.length > 1) {
                        return { ...openBet };
                    }
                    return {
                        ...openBet,
                        stake: getFormattedInputValue(String(distributions[distributionIndex++]), state.systemLanguage, state.systemCurrency)
                    }
                })

            } else if (state.quickFillBoxChecked && atleastOneValidAccaPresent) {
                let distributions = getQuickAmountDistribution('', (process.env.NODE_ENV !== 'development' && BMS && BMS.authentication && BMS.authentication.isPlayerLogged && state.playerBalance)
                    ? state.playerBalance.Banks.CREDIT.MinorCurrencyUnits
                    : 2, filterOutRealBetsFromOpenlist(newOpenBetsList).length);
                let distributionIndex = 0;
                newOpenBetsList = newOpenBetsList.map((openBet, index) => {
                    if (openBet.hasOwnProperty('PromoBetId')) {
                        return { ...openBet };
                    }
                    if (openBet.hasOwnProperty('multiplier') || openBet.bets.length > 1) {
                        return { ...openBet };
                    }
                    return {
                        ...openBet,
                        stake: getFormattedInputValue(String(distributions[distributionIndex++]), state.systemLanguage, state.systemCurrency)
                    }
                })
            }

            updateSportsBookLocalOpenBets(newOpenBetsList, state.playerUID);

            return {
                ...state,
                openBetsList: newOpenBetsList,
                openBetsSimpleList: newOpenBetsSimpleList,
                isBetSlipModalOpen: newIsBetSlipModalOpen,
                selectedBetSlipScreen: newSelectedBetSlipScreen,
                selectedEventMultiBetList: newSelectedEventMultiBetList,
                isBetHistoryOpen: false,
                quickFillBoxChecked: atleastOneValidAccaPresent ? false : state.quickFillBoxChecked,
                quickFillBoxDisabled: atleastOneValidAccaPresent ? true : false
            };
        case TOOGLE_EW_BET:

            let betSelection = state.openBetsList.find(ob => ob === action.betSelection);
            let betSelectionIndex = state.openBetsList.indexOf(betSelection);
            //each way for promo bet
            if (betSelection.hasOwnProperty('PromoBetId')) {
                promoId = String(betSelection.PromoBetId);
                //add stake value
                let selectedPromoIndex = newMyOfferList.findIndex(ob => ob.PromoBetId === promoId);
                //esachway should have refernceid
                let majorPromoValue = amountConvertToMajorCurrency(newMyOfferList[selectedPromoIndex].PromoBetValue, state.playerBalance.Banks.CREDIT.MinorCurrencyUnits);
                if (betSelection.bets[0].externalRefId === undefined) {
                    betSelection.stake = getFormattedInputValue(String((majorPromoValue / 2)), state.systemLanguage, state.systemCurrency);
                } else {
                    betSelection.stake = getFormattedInputValue(String((majorPromoValue)), state.systemLanguage, state.systemCurrency);
                }

            }

            //if there is only a to win bet
            if (betSelection.bets[0].externalRefId === undefined) {
                let newBetType;
                if (!isDogsEvent(betSelection.bets[0].event.eventType)) {
                    newBetType = SHOW;
                } else {
                    newBetType = PLACE;
                }
                let newBetMarket = newBetType.code + '_' + betSelection.bets[0].racers[0].num;

                newOpenBetsList[betSelectionIndex].bets[0].externalRefId = newBetMarket;
                newOpenBetsSimpleList[betSelectionIndex].bets[0].externalRefId = newBetMarket;

            } else {
                // remove externalId reference
                delete newOpenBetsList[betSelectionIndex].bets[0].externalRefId;
                delete newOpenBetsSimpleList[betSelectionIndex].bets[0].externalRefId;
            }

            updateSportsBookLocalOpenBets(newOpenBetsList, state.playerUID);

            return {
                ...state,
                openBetsList: newOpenBetsList,
                openBetsSimpleList: newOpenBetsSimpleList
            };
        case REMOVE_OPEN_BET:
            if (newOpenBetsList.length > 0) {
                _updateExistingAccBets(action.bet, newOpenBetsList, newMyOfferList);
                let indexOfBetInListOfOpenBetsList = newOpenBetsList.indexOf(action.bet);
                if (indexOfBetInListOfOpenBetsList < 0) return state;
                //before splice the bet ,check if there is promo id and update the count back to promo
                let deleteBet = newOpenBetsList[indexOfBetInListOfOpenBetsList];
                let promoId = '';
                if (deleteBet.hasOwnProperty('PromoBetId')) {
                    promoId = String(deleteBet.PromoBetId);
                    let selectedPromo = newMyOfferList.filter(ob => ob.PromoBetId === promoId);
                    //increment freebet count as removed from the selected bet
                    let selectedPromoIndex = newMyOfferList.findIndex(ob => ob.PromoBetId === promoId);
                    //
                    if (selectedPromoIndex >= 0)
                        newMyOfferList[selectedPromoIndex].PromoBetCnt = selectedPromo[0].PromoBetCnt + 1;

                }

                newOpenBetsList.splice(indexOfBetInListOfOpenBetsList, 1);
                let betsWithOutMultiplierArr = newOpenBetsList.filter(bet => bet.bets.length === 1)

                if (action.bet.bets.length === 1 && (action.isLastBet || action.isLastBet === undefined)) {
                    _generateAccumulatorBets(newOpenBetsList, newOpenBetsSimpleList);
                    atleastOneValidAccaPresent = isAccaBetPresentInBetSlip(newOpenBetsList);
                }
                if (newOpenBetsList.length > 0 && state.quickFillBoxChecked && state.quickFillStake !== '' && atleastOneValidAccaPresent !== undefined && !atleastOneValidAccaPresent) {
                    let distributions = getQuickAmountDistribution(state.quickFillStake, (process.env.NODE_ENV !== 'development' && BMS && BMS.authentication && BMS.authentication.isPlayerLogged && state.playerBalance)
                        ? state.playerBalance.Banks.CREDIT.MinorCurrencyUnits
                        : 2, filterOutRealBetsFromOpenlist(betsWithOutMultiplierArr).length);
                    let distributionIndex = 0;
                    newOpenBetsList = newOpenBetsList.map((openBet, index) => {
                        if (openBet.hasOwnProperty('PromoBetId')) {
                            return { ...openBet };
                        }
                        if (openBet.hasOwnProperty('multiplier')) {
                            return { ...openBet };
                        }

                        return {
                            ...openBet,
                            stake: getFormattedInputValue(String(distributions[distributionIndex++]), state.systemLanguage, state.systemCurrency)
                        }
                    })
                } else if (state.quickFillBoxChecked && atleastOneValidAccaPresent!==undefined && atleastOneValidAccaPresent) {
                    let distributions = getQuickAmountDistribution('', (process.env.NODE_ENV !== 'development' && BMS && BMS.authentication && BMS.authentication.isPlayerLogged && state.playerBalance)
                        ? state.playerBalance.Banks.CREDIT.MinorCurrencyUnits
                        : 2, filterOutRealBetsFromOpenlist(betsWithOutMultiplierArr).length);
                    let distributionIndex = 0;
                    newOpenBetsList = newOpenBetsList.map((openBet, index) => {
                        if (openBet.hasOwnProperty('PromoBetId')) {
                            return { ...openBet };
                        }
                        if (openBet.hasOwnProperty('multiplier')) {
                            return { ...openBet };
                        }
                        return {
                            ...openBet,
                            stake: getFormattedInputValue(String(distributions[distributionIndex++]), state.systemLanguage, state.systemCurrency)
                        }
                    })
                }

                newOpenBetsSimpleList = newOpenBetsList.slice();


            }
            updateSportsBookLocalOpenBets(newOpenBetsList, state.playerUID);

            return {
                ...state,
                openBetsList: newOpenBetsList,
                openBetsSimpleList: newOpenBetsSimpleList,
                isBetSlipModalOpen: newIsBetSlipModalOpen,
                quickFillBoxDisabled: atleastOneValidAccaPresent,
                quickFillBoxChecked: atleastOneValidAccaPresent ? false : state.quickFillBoxChecked,
                promoBalances: newMyOfferList
            };
        case REMOVE_CLOSED_EVENTS_OPEN_BETS:
            let expiredPromoBets = newOpenBetsList.filter(ob => ob.bets[0].hasExpired === true && ob.hasOwnProperty('PromoBetId'));
            if(expiredPromoBets.length > 0){
                expiredPromoBets.map(deleteBet => {
                promoId = String(deleteBet.PromoBetId);
                let selectedPromo = newMyOfferList.filter(ob => ob.PromoBetId === promoId);
                //increment freebet count as removed from the selected bet
                let selectedPromoIndex = newMyOfferList.findIndex(ob => ob.PromoBetId === promoId);
                newMyOfferList[selectedPromoIndex].PromoBetCnt = selectedPromo[0].PromoBetCnt + 1;})
            }

            newOpenBetsList = newOpenBetsList.filter(ob => ob.bets[0].hasExpired !== true);
            //remove bets from disabled games
            newOpenBetsList = newOpenBetsList.filter(ob => state.games.find(g => g.channel === ob.bets[0].game.channel).state.toString() === ENABLED);
            newOpenBetsSimpleList = newOpenBetsList.slice();
            if(newOpenBetsList.length > 0){
            atleastOneValidAccaPresent = isAccaBetPresentInBetSlip(newOpenBetsList);
            if (newOpenBetsList.length > 0 && state.quickFillBoxChecked && state.quickFillStake !== '' && !atleastOneValidAccaPresent) {
                let betsWithOutMultiplierArr = newOpenBetsList.filter(bet => bet.bets.length === 1);
                let distributions = getQuickAmountDistribution(state.quickFillStake, (process.env.NODE_ENV !== 'development' && BMS && BMS.authentication && BMS.authentication.isPlayerLogged && state.playerBalance) ? state.playerBalance.Banks.CREDIT.MinorCurrencyUnits
                : 2, filterOutRealBetsFromOpenlist(betsWithOutMultiplierArr).length);
                let distributionIndex = 0;
                newOpenBetsList = newOpenBetsList.map((openBet, index) => {
                    if (openBet.hasOwnProperty('PromoBetId')){
                        return {...openBet};
                    }
                    if (openBet.hasOwnProperty('multiplier')){
                        return {...openBet};
                    }

                    return {
                        ...openBet,
                        stake: getFormattedInputValue(String(distributions[distributionIndex++]), state.systemLanguage, state.systemCurrency)}
                })
                
            }else if(state.quickFillBoxChecked && atleastOneValidAccaPresent){
                    let distributions = getQuickAmountDistribution('', (process.env.NODE_ENV !== 'development' && BMS && BMS.authentication && BMS.authentication.isPlayerLogged && state.playerBalance)
                        ? state.playerBalance.Banks.CREDIT.MinorCurrencyUnits
                        : 2, filterOutRealBetsFromOpenlist(betsWithOutMultiplierArr).length);
                    let distributionIndex = 0;
                    newOpenBetsList = newOpenBetsList.map((openBet, index) => {
                        if (openBet.hasOwnProperty('PromoBetId')){
                            return {...openBet};
                        }
                        if (openBet.hasOwnProperty('multiplier')){
                            return {...openBet};
                        }
                        return {
                            ...openBet,
                            stake: getFormattedInputValue(String(distributions[distributionIndex++]), state.systemLanguage, state.systemCurrency)
                        }
                    })
                }
            }

            newOpenBetsSimpleList = newOpenBetsList.slice();
            updateSportsBookLocalOpenBets(newOpenBetsList, state.playerUID);

            return {
                ...state,
                openBetsList: newOpenBetsList,
                openBetsSimpleList: newOpenBetsSimpleList,
                quickFillBoxChecked: atleastOneValidAccaPresent ? false : state.quickFillBoxChecked,
                quickFillBoxDisabled: atleastOneValidAccaPresent ? true : false,
                promoBalances: newMyOfferList
            };
        case UPDATE_OPEN_BET_STAKE:
            if (newOpenBetsList.length > 0) {
                let betSelection = action.bet;
                let indexOfBetInListOfOpenBetsList = newOpenBetsList.indexOf(betSelection);
                newBetSelection = newOpenBetsList[indexOfBetInListOfOpenBetsList];
                newBetSelection.stake = action.stake;
            }

            updateSportsBookLocalOpenBets(newOpenBetsList, state.playerUID);

            return {
                ...state,
                openBetsList: newOpenBetsList
            };

        case UPDATE_OPEN_BET_MULTIPLIER:
            if (newOpenBetsList.length > 0) {
                let betSelection = action.bet;
                let indexOfBetInListOfOpenBetsList = newOpenBetsList.indexOf(betSelection);
                newBetSelection = newOpenBetsList[indexOfBetInListOfOpenBetsList];
                newBetSelection.multiplier = action.multiplier;
            }
            updateSportsBookLocalOpenBets(newOpenBetsList, state.playerUID);

            return {
                ...state,
                openBetsList: newOpenBetsList
            };

        case CLEAR_OPEN_BETS_LIST:
            if (action.keepBetsWithoutStake) {
                newOpenBetsList = state.openBetsList.slice();

                let removeBets = newOpenBetsList.filter((ob) => ob.stake !== undefined && ob.stake !== '' && Number(ob.stake) !== 0);
                //removing all single bets while placing an acca.
                removeBets.forEach(bet => {
                    if (bet.bets.length > 1)
                        _removeSingleBets(bet, newOpenBetsList);
                });
                let accaBets = newOpenBetsList.filter((ob) => ob.bets.length > 1);
                accaBets.length > 0 ? removeBets.forEach(removeBet => {
                    _updateExistingAccBets(removeBet, newOpenBetsList);
                }) : '';

                newOpenBetsList = newOpenBetsList.filter((ob) => ob.stake === undefined || ob.stake === '' || Number(ob.stake) === 0);
                newOpenBetsSimpleList = newOpenBetsList.slice();
                atleastOneValidAccaPresent = isAccaBetPresentInBetSlip(newOpenBetsList);
            } else {
                newOpenBetsList.map(deleteBet => {
                    if (deleteBet.hasOwnProperty('PromoBetId')) {
                        promoId = String(deleteBet.PromoBetId);
                        let selectedPromo = newMyOfferList.filter(ob => ob.PromoBetId === promoId);
                        //increment freebet count as removed from the selected bet
                        let selectedPromoIndex = newMyOfferList.findIndex(ob => ob.PromoBetId === promoId);
                        newMyOfferList[selectedPromoIndex].PromoBetCnt = selectedPromo[0].PromoBetCnt + 1;

                    }
                })
                newOpenBetsList = defaultStoreValues.openBetsList.slice();
                newOpenBetsSimpleList = defaultStoreValues.openBetsSimpleList.slice();
            }

            updateSportsBookLocalOpenBets(newOpenBetsList, state.playerUID);

            return {
                ...state,
                openBetsList: newOpenBetsList,
                openBetsSimpleList: newOpenBetsSimpleList,
                quickFillBoxChecked: state.quickFillBoxChecked,
                quickFillBoxDisabled: action.keepBetsWithoutStake && atleastOneValidAccaPresent ? true : false,
                promoBalances: newMyOfferList
            };
        case TOGGLE_COMMIT_BETS_SUCCESS:
            let newBetsCommitted = !state.betsCommitted;
            newSelectedBetSlipScreen = state.selectedBetSlipScreen;

            if (newBetsCommitted === false && state.isBetSlipModalOpen === true && state.selectedBetSlipScreen === OPEN_BETS) {
                newSelectedBetSlipScreen = PLACED_BETS;
            }

            return {
                ...state,
                betsCommitted: newBetsCommitted,
                selectedBetSlipScreen: newSelectedBetSlipScreen,
            };
        case TOGGLE_COMMIT_BETS_ERROR:
            let newBetsFailedBeingCommitted = !state.betsFailedBeingCommitted;
            newOpenBetsList = state.openBetsList.slice();
            // flag all open bets with commit error
            if (newBetsFailedBeingCommitted) {
                newOpenBetsList = newOpenBetsList.map((obet) => {
                    obet.failedCommitting = true;
                    return obet;
                });
                updateSportsBookLocalOpenBets(newOpenBetsList, state.playerUID);
            }

            return {
                ...state,
                betsFailedBeingCommitted: newBetsFailedBeingCommitted,
                openBetsList: newOpenBetsList,
            };
        case TOGGLE_COMMITTING_BETS:
            let newBetsCommitting = !state.betsCommitting;

            return {
                ...state,
                betsCommitting: newBetsCommitting
            };
        case ADD_LOCAL_STORED_BETS:
            return {
                ...state,
                openBetsList: action.openBetsList,
                openBetsSimpleList: action.openBetsList,
            }
        case DO_QUICK_FILL_BETS:
            if (newOpenBetsList.length > 0) {
                // multiplierBetCount gives number of invalid acca bets present in betslip
                let multiplierBetCount = newOpenBetsList.filter(bet => bet.hasOwnProperty('multiplier')).length;
                let betSlipLength = (multiplierBetCount >= 0) ? filterOutRealBetsFromOpenlist(newOpenBetsList).length - multiplierBetCount : filterOutRealBetsFromOpenlist(newOpenBetsList).length;
                let distributions = getQuickAmountDistribution(action.quickFillStake, action.minorCurrencyUnits, betSlipLength);
                let distributionIndex = 0;
                newOpenBetsList = newOpenBetsList.map((openBet, index) => {
                    if (openBet.hasOwnProperty('multiplier')) {
                        return { ...openBet };
                    }
                    if (openBet.hasOwnProperty('PromoBetId')) {
                        return { ...openBet };
                    }

                    return {
                        ...openBet,
                        stake: getFormattedInputValue(
                            String(distributions[distributionIndex++]),
                            action.systemLanguage,
                            action.systemCurrency
                        ),
                    };
                });

            }
            updateSportsBookLocalOpenBets(newOpenBetsList, state.playerUID);
            return {
                ...state,
                openBetsList: newOpenBetsList,
                quickFillStake: action.quickFillStake
            };
        case TOGGLE_QUICK_FILL:
            if (action.quickFillBoxCheckStatus) {
                return {
                    ...state,
                    quickFillBoxChecked: true,
                    quickFillStake: ''
                };
            } else {
                return {
                    ...state,
                    quickFillBoxChecked: false
                };
            }
        case DISABLE_QUICK_FILL:
            if (action.quickFillDisableStatus) {
                return {
                    ...state,
                    quickFillBoxDisabled: true,
                    quickFillBoxChecked: false,
                    quickFillStake: ''
                };
            } else {
                return {
                    ...state,
                    quickFillBoxDisabled: false
                };
            }
        case UNCHECK_QUICK_FILL:
            return {
                ...state,
                quickFillBoxChecked: false,
                quickFillStake: ''
            };

        case APPLY_PROMO_BET:
            if (newOpenBetsList.length > 0) {
                let betSelection = action.bet;
                let promoId = action.promoId;
                let indexOfBetInListOfOpenBetsList = newOpenBetsList.findIndex(bet => _.isEqual(bet, betSelection));
                newBetSelection = newOpenBetsList[indexOfBetInListOfOpenBetsList];
                let selectedPromo = newMyOfferList.filter(ob => ob.PromoBetId === promoId);

                newOpenBetsList[indexOfBetInListOfOpenBetsList].promo = 'applied';
                newOpenBetsList[indexOfBetInListOfOpenBetsList].PromoBetId = promoId;

                //converting to major currency
                let convertedPromoValue = amountConvertToMajorCurrency(selectedPromo[0].PromoBetValue[0], state.playerBalance.Banks.CREDIT.MinorCurrencyUnits)

                if (betSelection.bets[0].externalRefId === undefined) {
                    newOpenBetsList[indexOfBetInListOfOpenBetsList].stake = getFormattedInputValue(
                        String(convertedPromoValue),
                        action.systemLanguage,
                        action.systemCurrency
                    )
                } else {
                    newOpenBetsList[indexOfBetInListOfOpenBetsList].stake = getFormattedInputValue(
                        String(convertedPromoValue / 2),
                        action.systemLanguage,
                        action.systemCurrency
                    )
                }

                let selectedPromoIndex = newMyOfferList.findIndex(ob => ob.PromoBetId === promoId);
                newMyOfferList[selectedPromoIndex].PromoBetCnt = selectedPromo[0].PromoBetCnt > 1 ? selectedPromo[0].PromoBetCnt - 1 : 0;

                //For rearranging betslip with quick fill stake
                if (newOpenBetsList.length > 0 && state.quickFillBoxChecked && state.quickFillStake !== '') {
                    // Second condition will check if the accabet is valid or not. 
                    let stakeValue = (newOpenBetsList.findIndex(bet => bet.hasOwnProperty('multiplier') && ( new Set(bet.bets.map(b => b.event.eventId)).size === bet.bets.length)) > 0) ? '' : state.quickFillStake;
                    let distributions = getQuickAmountDistribution(stakeValue, (process.env.NODE_ENV !== 'development' && BMS && BMS.authentication && BMS.authentication.isPlayerLogged && state.playerBalance)
                        ? state.playerBalance.Banks.CREDIT.MinorCurrencyUnits
                        : 2, removePromoBetAndAccaBet(newOpenBetsList).length);
                    let distributionIndex = 0;
                    newOpenBetsList = newOpenBetsList.map((openBet, index) => {
                        if (openBet.hasOwnProperty('PromoBetId')) {
                            return { ...openBet };
                        }
                        if (openBet.hasOwnProperty('multiplier')) {
                            return { ...openBet };
                        }
                        return {
                            ...openBet,
                            stake: getFormattedInputValue(String(distributions[distributionIndex++]), state.systemLanguage, state.systemCurrency)
                        }
                    })
                }

            }
            updateSportsBookLocalOpenBets(newOpenBetsList, state.playerUID);

            return {
                ...state,
                openBetsList: newOpenBetsList,
                promoBalances: newMyOfferList
            };

        case SELECTED_BET:
            let betSelected = action.bet;
            return {
                ...state,
                selectedBet: betSelected
            };

        case UPDATE_UI_STATE_TIMER:
            let busyStateTimer = action.busyStateTimer;
            return {
                ...state,
                busyStateTimeoutId: busyStateTimer,
            };
        case UPDATE_UI_STATE:
            let status = action.status;
            return {
                ...state,
                isUserInterfaceBusy: status,
            };
        case REMOVE_PROMO_BET:
            betSelection = action.bet;
            //find campaign  id from selected bet then remove the promo and campaignId  from betslection
            let indexOfBetInListOfOpenBetsList = newOpenBetsList.indexOf(betSelection);
            newBetSelection = newOpenBetsList[indexOfBetInListOfOpenBetsList];
            let promoId = newBetSelection.PromoBetId;
            let selectedPromo = newMyOfferList.filter(ob => ob.PromoBetId === promoId);
            //increment freebet count as removed from the selected bet
            if(selectedPromo.length >0){
                let selectedPromoIndex = newMyOfferList.findIndex(ob => ob.PromoBetId === promoId);
                 newMyOfferList[selectedPromoIndex].PromoBetCnt = selectedPromo[0].PromoBetCnt + 1;
            }

            //remove promo and campaignId from JSON structure and update the stake
            delete newBetSelection['promo'];
            delete newBetSelection['PromoBetId'];
            newBetSelection.stake = getFormattedInputValue(
                String(0),
                action.systemLanguage,
                action.systemCurrency
            )

            //For rearranging betslip with quick fill stake
            if (newOpenBetsList.length > 0 && state.quickFillBoxChecked && state.quickFillStake !== '') {
                let stakeValue = (newOpenBetsList.findIndex(bet => bet.hasOwnProperty('multiplier') && ( new Set(bet.bets.map(b => b.event.eventId)).size === bet.bets.length)) > 0) ? '' : state.quickFillStake;
                let distributions = getQuickAmountDistribution(stakeValue, (process.env.NODE_ENV !== 'development' && BMS && BMS.authentication && BMS.authentication.isPlayerLogged && state.playerBalance)
                    ? state.playerBalance.Banks.CREDIT.MinorCurrencyUnits
                    : 2, removePromoBetAndAccaBet(newOpenBetsList).length);
                let distributionIndex = 0;
                newOpenBetsList = newOpenBetsList.map((openBet, index) => {
                    if (openBet.hasOwnProperty('PromoBetId')) {
                        return { ...openBet };
                    }

                    if (openBet.hasOwnProperty('multiplier')) {
                        return { ...openBet };
                    }
                    return {
                        ...openBet,
                        stake: getFormattedInputValue(String(distributions[distributionIndex++]), state.systemLanguage, state.systemCurrency)
                    }
                })
            }

            return {
                ...state,
                promoBalances: newMyOfferList,
                openBetsList: newOpenBetsList
            };
        case AUTO_FOCUS_QUICK_FILL:
            return {
                ...state,
                quickFillAutoFocusEnabled: true,
                quickFillBoxChecked: true,
                quickFillStake: '',
                    };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/reducers/openBetsReducer.js